import { render } from "./MergeCompanies.vue?vue&type=template&id=11146fd2&scoped=true"
import script from "./MergeCompanies.vue?vue&type=script&lang=js"
export * from "./MergeCompanies.vue?vue&type=script&lang=js"

import "./MergeCompanies.vue?vue&type=style&index=0&id=11146fd2&lang=sass&scoped=true"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11146fd2"]])

export default __exports__